import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'
import DownloadFile from '@/core/utils/DownloadFile'

export default {
	async [actionTypes.ATA.DOCUMENTO.BAIXAR_DOCUMENTO_ATA](context, idDocumento) {
		const response = await api.documentosAta.baixar(idDocumento)
		const headers = response.headers

		DownloadFile.downloadArrayBuffer(response.data, headers.filename, headers['content-type'], headers.extension)
	},
	async [actionTypes.ATA.DOCUMENTO.BUSCAR_POR_FILTRO]({ state }) {
		const { filtro, paginacao, idAta } = state

		const { data } = await api.documentosAta.buscarDocumentosPorFiltro(filtro, paginacao, idAta)
		return data
	},
}
